import React from 'react';
import styles from '../styles/FranchiseeServices.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Link from 'next/link';
import CustomImage from "./CustomImage";
import Recognition from './Recognition';
import FeaturedBlogs from './FeaturedBlogs';
import Testimonial from './Testimonial';
import TopTieUpsOfKC from './UniTieUp';
import KcNewLatestUpdates from './kcNewlatestupdates';
import FeaturedPartnerWebinars from './FeaturedPartnerWebinars';
import FaqComponent from './PST/FrequentlyAskedQuestions';
import VideoTestimonials from './PST/VideoTestimonials';
import Table from 'react-bootstrap/Table';
import FranchiseeModel from './PST/FranchiseeModel';
import { isFrappeOrJotFormClass } from '../utils/helpers';

const ServicesFranchiseepage: React.FC = (props: any) => {
  return (
    <div id='serv-franchisee' className={styles.franchisee}>
      <div className={styles.curve}>
        <div className={styles.contentDiv}>
          <Container>
            <Row>
              <Col lg={6} md={6} xs={12}>
                <div className='d-block d-sm-none text-center'>
                  <div className='d-flex justify-content-center'>
                    <Breadcrumb className={styles.mobileBreadCrum}>
                      <Breadcrumb.Item href='/' active>
                        Services
                      </Breadcrumb.Item>
                      <Breadcrumb.Item href=''>For Franchisee</Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                  <CustomImage
                    src={
                      props.pageData.mainImageUrl ||
                      '/images/franchisee/franchisee.svg'
                    }
                    alt={props.pageData.mainImageAltTag || ''}
                    width={513}
                    height={424}
                    className={styles.mobileImg}
                  />
                </div>
                <div className={styles.servContent}>
                  <Breadcrumb className='d-none d-sm-block'>
                    <Breadcrumb.Item href='/' active>
                      Services
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href=''>For Franchisee</Breadcrumb.Item>
                  </Breadcrumb>
                  <h1>{props?.pageData?.title}</h1>
                  <p>{props?.pageData?.description}</p>
                  <div className={styles.buttons}>
                    <a
                      className={`${styles.EnquireNow} ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0].jotformid)}`}
                    >
                      Enquire Now
                    </a>
                    <a
                      className={`${styles.more
                        } ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[1].jotformid)}`}
                    >
                      Request a Callback
                    </a>
                  </div>
                </div>
              </Col>
              <Col lg={6} md={6} xs={12}>
                {/* Desktop img */}
                <div className='d-none d-sm-block text-center'>
                  <CustomImage
                    src={
                      props.pageData.mainImageUrl ||
                      '/images/franchisee/franchisee.svg'
                    }
                    alt={props.pageData.mainImageAltTag || ''}
                    width={513}
                    height={424}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      <div className={styles.WhyKc}>
        <Container>
          <Row>
            <div className='text-center'>
              <h2>Why KC?</h2>
            </div>
          </Row>
          <Row>
            {props?.pageData?.whyKc?.length > 0 &&
              props?.pageData?.whyKc.map((kcBenefit: any) => {
                return (
                  <Col xl={4} md={4} xs={12}>
                    <div className='text-center mb-3'>
                      <div className={styles.img}>
                        <CustomImage
                          src={kcBenefit?.imagePath}
                          alt={kcBenefit?.imageAltTag}
                          width={150}
                          height={150}
                        />
                      </div>
                      <h6>{kcBenefit?.title}</h6>
                      <p>{kcBenefit?.description}</p>
                      {/* <a className={styles.viewMore}>Know More</a> */}
                    </div>
                  </Col>
                );
              })}
          </Row>
        </Container>
      </div>

      {/* Franchisee Model*/}
      <FranchiseeModel franchiseeModelData={props?.pageData?.franchiseeModelSection} />
      
      {/* Why Choosing KC is the Right Business Decision? */}
      <div className={styles.topPriority}>
        <Container>
          <Row className='text-center'>
            <h2>Why Choosing KC is the Right Business Decision?</h2>
          </Row>
          <Row>
            <Col lg={6} md={6} sm={6} xs={12}>
              <div className={styles.commission}>
                <CustomImage
                  src={props?.pageData?.choosingKc?.imagePath}
                  alt='Business-Decision.svg'
                  width={490}
                  height={440}
                />
              </div>
            </Col>
            <Col lg={6} md={6} sm={6} xs={12}>
              <div className={styles.commissionsContent}>
                <h5 className={styles.subHeadStyle}>
                  {props?.pageData?.choosingKc?.serviceTitle}
                </h5>
                <p className={styles.subHeadParat}>
                  {props?.pageData?.choosingKc?.serviceDesc}
                </p>
                <ul className='pl-0'>
                  {props?.pageData?.choosingKc?.offerings?.length > 0 &&
                    props?.pageData?.choosingKc?.offerings.map(
                      (offer: string, index: number) => (
                        <li key={index} className={styles.subHeadUlLi}>
                          {offer}
                        </li>
                      )
                    )}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Technological Capabilities */}
      <div className={styles.TechCapabilities}>
        <Container>
          <Row className='text-center'>
            <h2>Technological Capabilities</h2>
          </Row>
          <Row>
            {/* desktop view */}
            <div>
              <div className={styles.techTabs}>
                <Tabs
                  defaultActiveKey='CourseFinder'
                  transition={false}
                  id='techCapabilityTabs'
                  className={styles.tabs}
                >
                  <Tab eventKey='CourseFinder' title='coursefinder.ai'>
                    <div className={styles.CourseFinder}>
                      {/* Course Finder */}
                      <div className={styles.TechCabMarBott}>
                        <Row>
                          <Col xs={12} lg={6}>
                            <div className={styles.CourseFinderContent}>
                              {/* mobile img */}
                              <div className='d-block d-sm-none'>
                                <div className={styles.platformDivImg}>
                                  <CustomImage
                                    src={
                                      props?.pageData?.courseFinder[0].imagePath
                                    }
                                    alt={
                                      props?.pageData?.courseFinder[0]
                                        .imageAltTag
                                    }
                                    width={333.98}
                                    height={279.13}
                                  />
                                </div>
                              </div>
                              <h2>{props?.pageData?.courseFinder[0].title}</h2>
                              <p>
                                {props?.pageData?.courseFinder[0].description}
                              </p>
                              <ul className='pl-0'>
                                {props?.pageData?.courseFinder[0].points.map(
                                  (point: any) => (
                                    <li>
                                      <h6>{point.title}</h6>
                                      <span>{point.description}</span>
                                    </li>
                                  )
                                )}
                              </ul>
                              <Link href='https://www.coursefinder.ai'>
                                <a target='_blank' className={styles.viewMore}>
                                  coursefinder.ai
                                </a>
                              </Link>
                            </div>
                          </Col>
                          <Col xs={12} lg={6}>
                            {/* desktop img */}
                            <div className=' d-none d-sm-block text-center'>
                              <div className={styles.platformDivImg}>
                                <CustomImage
                                  src={
                                    props?.pageData?.courseFinder[0].imagePath
                                  }
                                  alt={
                                    props?.pageData?.courseFinder[0].imageAltTag
                                  }
                                  width={579}
                                  height={547}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Tab>
                  <Tab eventKey='ElanLoans' title='Elan Loans'>
                    <div className={styles.CourseFinder}>
                      <div className={styles.TechCabMarBott}>
                        <Row>
                          <Col xs={12} lg={6}>
                            <div className={styles.CourseFinderContent}>
                              {/* mobile img */}
                              <div className='d-block d-sm-none'>
                                <div className={styles.platformDivImg}>
                                  <CustomImage
                                    src={
                                      props?.pageData?.elanLoans[0].imagePath
                                    }
                                    alt={
                                      props?.pageData?.elanLoans[0].imageAltTag
                                    }
                                    width={333.98}
                                    height={279.13}
                                  />
                                </div>
                              </div>
                              <h2>{props?.pageData?.elanLoans[0].title}</h2>
                              <p>{props?.pageData?.elanLoans[0].description}</p>
                              <ul className='pl-0'>
                                {props?.pageData?.elanLoans[0].points.map(
                                  (point: any) => (
                                    <li>
                                      <h6>{point.title}</h6>
                                      <span>{point.description}</span>
                                    </li>
                                  )
                                )}
                              </ul>
                              <Link href='https://www.elanloans.com/'>
                                <a target='_blank' className={styles.viewMore}>
                                  Elan Loans
                                </a>
                              </Link>
                            </div>
                          </Col>
                          <Col xs={12} lg={6}>
                            {/* desktop img */}
                            <div className=' d-none d-sm-block '>
                              <div className={styles.platformDivImg}>
                                <CustomImage
                                  src={props?.pageData?.elanLoans[0].imagePath}
                                  alt={
                                    props?.pageData?.elanLoans[0].imageAltTag
                                  }
                                  width={579}
                                  height={547}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </Row>
        </Container>
      </div>

      {/*Events and Promotions & Numbers that speak volumes */}

      <div className={styles.TechCap}>
        <div className={styles.TechCabMarBott}>
          <Container>
            <Row>
              {props?.pageData?.otherCapabilities?.length > 0 &&
                props?.pageData?.otherCapabilities.map(
                  (capability: any, index: number) => {
                    return (
                      <>
                        {index / 2 === 0 && (
                          <Col xs={12} lg={6}>
                            {/* desktop img */}
                            <div className=' d-none d-sm-block text-center'>
                              <div className={styles.platformDivImg}>
                                <CustomImage
                                  src={
                                    capability.sectionImageurl ||
                                    '/images/franchisee/events-and-promotions.svg'
                                  }
                                  alt={capability.sectionImageAltTag || ''}
                                  width={490}
                                  height={440}
                                />
                              </div>
                            </div>
                          </Col>
                        )}
                        <Col xs={12} lg={6}>
                          <div className={styles.EmpoweringYou}>
                            {/* mobile img */}
                            <div className='d-block d-sm-none'>
                              <div
                                className={`${styles.platformDivImg} ${styles.platformDivImgMobile}`}
                              >
                                <CustomImage
                                  src={
                                    capability.sectionImageurl ||
                                    '/images/franchisee/events-and-promotions.svg'
                                  }
                                  alt={capability.sectionImageAltTag || ''}
                                  width={400}
                                  height={400}
                                />
                              </div>
                            </div>
                            <div className={styles.EmpoweringYouContent}>
                              <div>
                                <h3 className='mb-4'>{capability.title}</h3>
                                <p>{capability.description}</p>
                                <ul className='pl-0'>
                                  {capability.points.map(
                                    (point: string, index: number) => (
                                      <li key={index}>{point}</li>
                                    )
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </Col>
                        {index / 2 !== 0 && (
                          <Col xs={12} lg={6}>
                            {/* desktop img */}
                            <div className=' d-none d-sm-block text-center'>
                              <div className={styles.platformDivImg}>
                                <CustomImage
                                  src={
                                    capability.sectionImageurl ||
                                    '/images/franchisee/speak-volumes.svg'
                                  }
                                  alt={capability.sectionImageAltTag || ''}
                                  width={490}
                                  height={440}
                                />
                              </div>
                            </div>
                          </Col>
                        )}
                      </>
                    );
                  }
                )}
            </Row>
          </Container>
        </div>
      </div>

      <div className={styles.potentialFranchisee}>
        <Container>
          <Row className='justify-content-md-center'>
            <Col lg={8} md={8}>
              <h2 className='text-center'>
                What do we Seek in our Potential Franchisee Partners?
              </h2>
            </Col>
          </Row>
          <div className={styles.content}>
            <Row className='justify-content-md-center'>
              <Col lg={6} md={6}>
                <div className={styles.box}>
                  <CustomImage
                    src='/images/franchisee/experience.svg'
                    alt='experience.svg'
                    width={50}
                    height={44}
                  />
                  <h5>Experience</h5>
                  <p>Entrepreneurs with relevant industry experience</p>
                </div>
              </Col>
              <Col lg={6} md={6}>
                <div className={styles.box}>
                  <div className={styles.box}>
                    <CustomImage
                      src='/new-images/financial-res.svg'
                      alt='financialRes.svg'
                      width={50}
                      height={44}
                    />
                    <h5>Financial Resources</h5>
                    <p>Good financial backing and investment potential</p>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={4} md={4}>
                <div className={styles.box}>
                  <CustomImage
                    src='/images/franchisee/overseasquali.svg'
                    alt='overseasquali.svg'
                    width={50}
                    height={44}
                  />
                  <h5>Overseas Qualification</h5>
                  <p>Professionals who have studied overseas</p>
                </div>
              </Col>
              <Col lg={4} md={4}>
                <div className={styles.kclogo}>
                  <CustomImage
                    src='/images/franchisee/kc-logo.svg'
                    alt='kc-logo.svg'
                    width={300}
                    height={60}
                  />
                </div>
              </Col>
              <Col lg={4} md={4}>
                <div className={styles.box}>
                  <div className={styles.box}>
                    <CustomImage
                      src='/images/franchisee/infrastr.svg'
                      alt='infrastr.svg'
                      width={50}
                      height={44}
                    />
                    <h5>Infrastructure</h5>
                    <p>A well-furnished office set up in commercial premises</p>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className='justify-content-md-center'>
              <Col lg={6} md={6}>
                <div className={styles.box}>
                  <CustomImage
                    src='/images/franchisee/businessacumen.svg'
                    alt='businessacumen.svg'
                    width={50}
                    height={44}
                  />
                  <h5>Business Acumen</h5>
                  <p>
                    Proven management capabilities and exceptional business
                    traits
                  </p>
                </div>
              </Col>
              <Col lg={6} md={6}>
                <div className={styles.box}>
                  <div className={`${styles.box} ${styles.boxSixth}`}>
                    <CustomImage
                      src='/images/franchisee/skills.svg'
                      alt='skills.svg'
                      width={50}
                      height={44}
                    />
                    <h5>Skills</h5>
                    <p>
                      Excellent English Communication, Marketing, Counselling &
                      Team Management
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
        <div>
          <div className={styles.studentFooter}>
            <Container>
              <div className={styles.session}>
                <Row>
                  <Col lg={7}>
                    <div className={styles.text}>
                      <h3>
                        Invest in a franchise opportunity promising rapid
                        business growth and lucrative returns.
                      </h3>
                    </div>
                  </Col>
                  <Col lg={5}>
                    <div className={styles.anchor}>
                      <a
                        href={props?.pageData?.meta?.jotforms[2].jotformscript}
                        target='_blank'
                        className={styles.reqCall}
                      >
                        Want more details
                      </a>
                      <a
                        className={`${styles.partnerBtn} ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0].jotformid)}`}
                      >
                        Enquire Now
                      </a>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
        </div>
      </div>

      <Testimonial
        title='Our franchisees love us'
        bgColor='#ffffff'
        slug={`testimonials?type=franchisee&_limit=15&_sort=id:DESC`}
      />
      {props.pageData?.videoTestimonial &&
        <VideoTestimonials {...props.pageData.videoTestimonial} />}
      <div className={styles.franchiseeWebinar}>
        <FeaturedPartnerWebinars title={'Webinars for Partners'} />
      </div>

      {/* Top 8 Tie Ups of KC in World’s Top 350 */}
      <div className={styles.franchiseeUniTie}>
        <TopTieUpsOfKC />
      </div>

      <div className={styles.franchiseeRecogni}>
        <Recognition bgColor={'#FBBFB6'} />
      </div>
      <div className={styles.franchiseeKcUpdates}>
        <KcNewLatestUpdates {...props} />
      </div>
      <div className={styles.franchiseeBlog}>
        <FeaturedBlogs />
      </div>
      {props.pageData?.faq &&
        <FaqComponent {...props.pageData.faq} />}
    </div>
  );
};
export default ServicesFranchiseepage;
